import React from 'react';

export interface VoxelButtonGridProps {
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  align?: 'left' | 'right';
  wrap?: boolean;
  className?: string;
}

export const VoxelButtonGrid: React.FC<VoxelButtonGridProps> = ({
  children,
  size = 'sm',
  className,
  align = 'left',
  wrap,
}) => {
  let sizeClass = '';
  if (size === 'xxs') {
    sizeClass = 'gap-1.5';
  }
  if (size === 'xs') {
    sizeClass = 'gap-3';
  }
  if (size === 'sm') {
    sizeClass = 'gap-4';
  }
  if (size === 'md') {
    sizeClass = 'gap-4';
  }
  if (size === 'lg') {
    sizeClass = 'gap-4';
  }
  if (size === 'xl') {
    sizeClass = 'gap-5';
  }

  let flexWrapClass = '';
  if (wrap) {
    flexWrapClass = 'flex-wrap';
  }
  if (!wrap) {
    flexWrapClass = 'flex-npwrap';
  }

  let alignClass = 'justify-start';
  if (align === 'right') alignClass = 'justify-end';

  return (
    <div
      className={`
          flex flex-row
          items-center
          ${alignClass}
          ${sizeClass}
          ${flexWrapClass}
          ${className}
        `}
    >
      {children}
    </div>
  );
};

export default VoxelButtonGrid;
